import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';

/**
 * Guard for org-owned accounts awaiting classification.
 *
 * "Pending" is a derived state (see docs/account-states.html): the
 * account's email domain belongs to an org (user_account.org_id is set)
 * but no admin has classified them as staff or student yet. Until then
 * the app is closed — they see the "waiting for your school" screen.
 */
export const orgPendingGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const user = await firstValueFrom(auth.$user);

  if (!user) {
    // Not authenticated — other guards handle it.
    return true;
  }

  if (user.org_pending) {
    router.navigate(['/waiting-for-school']);
    return false;
  }

  return true;
};
